import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ModalPresenter from './ModalPresenter'
import StorageService from '../../../services/storage.service'
import { modalActions } from '../../../stores/action/widget.action'
import { useEffect } from 'react'

function ModalContainer({ModalActions, id, status, ...rest}) {

    useEffect(()=> {
        ModalActions.showStart(id);
    }, []);

    const handleShowModal = id => {
        ModalActions.showStart(id);
    }

    const handleLimitModal = id => {
        var date = new Date();
        let date_start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0); // year, month, day, hours, minutes, seconds, milliseconds

        const todayDate = date_start.getTime();
        let checkDate = todayDate + (1 * 24 * 60 * 60 * 1000);
        
        const lastDate = String(id) + '|' + String(checkDate);

        new StorageService().notModal.set(lastDate)
        ModalActions.showStart(0)
    }

    const handleLimitModalCheck = id => {
        
        let saved = new StorageService().notModal.get();
        if (!saved) {
            return true;
        }
        
        let results = saved.split('|');
        if (results[0] !== id ) {
            return true;
        }

        if(results[1]) {
            return Number(results[1]) > new Date().getTime() ? false : true
        } else {
            return true
        }
    }

    // console.log("ModalContainer+++ status", status);
    return (
        <ModalPresenter id={id} status={status} onShowModal={handleShowModal} onLimitModal={handleLimitModal} onLimitModalCheck={handleLimitModalCheck} {...rest}/>
    );
}

// export default ModalContainer
export default connect(
    state => ({
        status: state.widget.getIn(['modalStart', 'status'])
    }),
    dispatch => ({
        ModalActions: bindActionCreators(modalActions, dispatch)
    })
)(ModalContainer);